// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-icon-size {\n  font-size: 24px !important;\n}\n.custom_content_wrap > .v-expansion-panel-content__wrap {\n  margin: 0;\n  padding: 0.4rem;\n}\n", ""]);
// Exports
module.exports = exports;
